import { render, staticRenderFns } from "./liveBox.vue?vue&type=template&id=1a14fab1&scoped=true"
import script from "./liveBox.vue?vue&type=script&lang=js"
export * from "./liveBox.vue?vue&type=script&lang=js"
import style0 from "./liveBox.vue?vue&type=style&index=0&id=1a14fab1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a14fab1",
  null
  
)

export default component.exports